<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="width100 margin-auto backwhite border-rd3">
          <!-- 内容 -->
          <div
            class="width100 text-ellipsis backwhite pad-bot20 margin-top10"
            v-if="total != 0"
          >
            <div
              class="
                f14
                lineheight35
                pad-left20 pad-right20 pad-top20 pad-bot10
                bordert-tf
                dimencont
              "
              v-for="(item, index) in pages"
              :key="index"
            >
              <div v-if="item.patent != null">
                <div
                  class="f14 flex-betweennowrap cursorpointer dimensional"
                  v-if="item.patent != null"
                >
                  <span @click="toPatentdatails(index)"
                    >{{ item.patent.title }}({{ item.patent.appNumber }})
                    <span
                      class="f12"
                      :class="
                        item.patent.dbName == '实用新型'
                          ? 'patensy'
                          : item.patent.dbName == '外观专利'
                          ? 'patenwg'
                          : item.patent.dbName == '发明专利'
                          ? 'patenzl'
                          : 'patensq'
                      "
                      >{{ item.patent.dbName }}</span
                    ></span
                  >
                  <p class="cursorpointer" @click="centerDialogVisible = true">
                    <el-button @click="todialog(index)" class="margin-right10"
                      >取消关注</el-button
                    >

                    <span
                      @click="dialogVisibledrawer = true"
                      v-if="item.ent_id == 0"
                    >
                      <el-button
                        @click="patenpush(index)"
                        class="margin-right10"
                        >分享给企业</el-button
                      >
                    </span>
                    <span v-if="item.ent_id != 0">
                      <el-button @click="nullshare(index)">取消分享</el-button>
                    </span>
                  </p>
                </div>
                <p
                  class="width70 flex-betweennowrap pad-top10"
                  @click="toPatentdatails(index)"
                >
                  <span>公开(公告)号:{{ item.patent.pubNumber }}</span>
                  <span>申请（专利权）人：{{ item.patent.patentee }}</span>
                  <span> 发明（设计）人：{{ item.patent.inventroName }}</span>
                </p>
                <p class="width70 flex-betweennowrap">
                  <span>国省代码:{{ item.patent.proCode }}</span>
                  <span>申请日:{{ item.patent.appDate }} </span>
                  <span>公开(公告)日:{{ item.patent.pubDate }}</span>
                </p>
                <p>分类号:{{ item.patent.ipc }}</p>
                <p>主分类号:{{ item.patent.mainIpc }}</p>
              </div>
            </div>
            <!-- 分页 -->
            <div
              v-if="total != 0"
              class="
                flex-betweennowrap
                pad-top20 pad-bot20
                pagination
                pad-right10
                bordert-tf
              "
            >
              <span></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChange"
                @current-change="currentchange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              >
              </el-pagination>
            </div>
          </div>

          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="total == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
            >
              <p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p>
            </el-empty>
          </div>
          <el-dialog
            title="请选择企业"
            :visible.sync="dialogVisibledrawer"
            :close-on-click-modal="false"
            :show-close="true"
            :modal="true"
            :modal-append-to-body="true"
            :append-to-body="true"
            width="50%"
            class="drawerbox"
          >
            <div class="newenterprises">
              <el-input
                placeholder="请输入内容"
                v-model="input3"
                class="input-with-select inputinner"
                @input="oninput()"
              >
                <el-button
                  @click="searchbut"
                  slot="append"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
            </div>
            <div class="enterprisebox" @scroll="scrollEvent">
              <div
                class="newenterprise"
                @click="onConfirm(index)"
                v-for="(item, index) in page"
                :key="index"
              >
                {{ item.company }}
              </div>
            </div>
            <div class="width98 margin-auto textalign-right">
              <el-button @click="dialogVisibledrawer = false">取 消</el-button>
              <el-button
                class="margin-top20"
                type="primary"
                @click="dialogVisibledrawer = false"
              >
                确 定
              </el-button>
            </div>
          </el-dialog>
          <el-dialog
            title=""
            :visible.sync="dialogVisiblenull"
            :close-on-click-modal="false"
            :show-close="true"
            :center="true"
            :modal="true"
            :modal-append-to-body="true"
            :append-to-body="true"
            width="25%"
            class="errorbox"
          >
            <span class="errormessage">{{ errormessage }}</span>
            <span slot="footer" class="dialog-footer">
              <button @click="dialogVisiblenull = false" class="errorbutton">
                确 定
              </button>
            </span>
          </el-dialog>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import {
  followpatentmyfollow,
  followpatentremove,
  followpatentpush,
  followpatentclose,
} from "@/api/patent/patent.api";
import { boundEnterprise } from "@/api/personal/personal.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibledrawer: false,
      direction: "btt",
      titlespan: "请选择企业",
      input3: "",
      page: "",
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      input: "",
      thisNums: 1,
      page1: [],
    };
  },
  components: {
    callback,
  },

  methods: {
    //滚动条触发事件
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // // 获取企业
        boundEnterprise({ limit: 30, page: ++this.thisNums }).then((res) => {
          if (res.data.code == 200) {
            // this.page = res.data.data.data;
            if (res.data.data.data.length == 0) {
              return;
            } else {
              this.page1 = res.data.data.data;
              this.page1.forEach((i) => {
                this.page.push(i);
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    searchbut() {
      if (this.input3 != "") {
        // // 获取企业
        boundEnterprise({ _keywords: this.input3 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    oninput() {
      if (this.input3 == "") {
        // // 获取企业
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.title = this.page[0].company;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    todialog(index) {
      this.$confirm("此操作将取消关注, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          followpatentremove({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //分享
    onConfirm(index) {
      followpatentpush({
        id: this.enpriseid,
        ent_id: this.page[index].ent_id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisibledrawer = false;
          this.$message({
            showClose: true,
            message: "分享成功",
            type: "success",
          });
          this.refresh();
        } else {
          this.dialogVisibledrawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 推送到企业
    patenpush(index) {
      this.enpriseid = this.pages[index].id;
    },
    // 取消分享
    nullshare(index) {
      this.$confirm("此操作将取消分享, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          followpatentclose({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消分享成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 跳转详情
    toPatentdatails(index) {
      window.sessionStorage.setItem(
        "patentlookout",
        this.pages[index].patent.id
      );
      this.$router.push({
        path: "/intellectual-property/patentlookout-details",
      });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      followpatentmyfollow({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      followpatentmyfollow({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      // // 获取企业
      boundEnterprise().then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          if (window.sessionStorage.getItem("default") == 0) {
            this.title = "个人版";
          } else {
            this.title = this.page[0].company;
            window.sessionStorage.setItem("companytitle", this.page[0].company);
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      this.$loading.show(); // 显示loading
      followpatentmyfollow({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.patent.dbName == "SYXX") {
              i.patent.dbName = "实用新型";
            }
            if (i.patent.dbName == "FMZL") {
              i.patent.dbName = "发明专利";
            }
            if (i.patent.dbName == "WGZL") {
              i.patent.dbName = "外观专利";
            }
            if (i.patent.dbName == "FMSQ") {
              i.patent.dbName = "发明授权";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    // // 获取企业
    boundEnterprise().then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        if (window.sessionStorage.getItem("default") == 0) {
          this.title = "个人版";
        } else {
          this.title = this.page[0].company;
          window.sessionStorage.setItem("companytitle", this.page[0].company);
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    this.$loading.show(); // 显示loading
    followpatentmyfollow({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.patent.dbName == "SYXX") {
            i.patent.dbName = "实用新型";
          }
          if (i.patent.dbName == "FMZL") {
            i.patent.dbName = "发明专利";
          }
          if (i.patent.dbName == "WGZL") {
            i.patent.dbName = "外观专利";
          }
          if (i.patent.dbName == "FMSQ") {
            i.patent.dbName = "发明授权";
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.newenterprise {
  text-align: left;
  line-height: 35px;
  color: #767676;
  /* border-bottom: 1px solid #efefef; */
  font-size: 14px;
  padding: 0 10px 0 20px;
  cursor: pointer;
}
.newenterprise:hover {
  background: #ecf8f9;
}
.newenterprises {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 35px;
  color: #767676;
  /* border-bottom: 1px solid #efefef; */
  font-size: 14px;
  padding: 0 10px 0 10px;
}
.paddingleft10 {
  padding-left: 10px;
}
.enterprisebox {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  /* border-top: 1px solid #efefef; */
}
.patensy {
  color: #7b83ea;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #ebecf1;
  border-radius: 11px;
}
.patenwg {
  color: #52c5cb;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e1e5e6;
  border-radius: 11px;
}
.patenzl {
  color: #f96d68;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e9e2e1;
  border-radius: 11px;
}
.patensq {
  color: #5599ff;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #eaebee;
  border-radius: 11px;
}
.dimencont:hover {
  background: #f9fcfc;
}
.addbut {
  color: #767676;
  margin: 5px 10px 0 0;
  padding: 3px;
  border: 1px solid #767676;
  border-radius: 3px;
  font-size: 12px;
}
.Keywordsinput >>> .el-input__inner {
  height: 50px;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 23px 0 0 23px;
  position: relative;
  left: 35%;
}
.Keywordsinput >>> .el-input-group__append,
.el-input-group__prepend {
  width: 60px;
  text-align: center;
  color: #fff;
  background: #52c5cb;
  border: 1px solid rgba(82, 197, 203, 1);
  border-radius: 0px 100px 100px 0px;
  position: relative;
  left: 25%;
  font-size: 16px;
}
.icon {
  font-size: 12px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>